<div class="sub-header px-3">
</div>
<div class="search-container py-3 align-items-center d-flex row px-3 mb-1 pb-4">
    <div class="col-md-4 catalog-header d-flex px-3 py-1">
        <h5 class="mb-0 px-0">Price Display Setup</h5>
    </div>
    <div class="col-md-8 px-4 search-input-block d-flex align-items-center justify-content-end">
        <ng-container>
            <button nz-button nzType="primary" class="d-flex align-items-center" [nzSize]="'default'"
                (click)="linkDrawer = !linkDrawer">
                Add Price Detail
            </button>
        </ng-container>
    </div>

</div>
<div class="row h-100 justify-content-center d-flex align-items-center" *ngIf="isLoading"><app-spinner></app-spinner>
</div>
<div [ngStyle]="{'height':priceDisplayData && priceDisplayData.length>0 ? '80vh': ''}"
    class="row p-0 mt-3 catalog-container justify-content-center  d-flex align-items-center" *ngIf="!isLoading">
    <div class="row p-0">
        <div class="col-md-12 row product-search-container p-3 mb-3 ml-5">
            <div class="col-md-5 mb-4 d-flex flex-column position-relative">

                <label class="form-label">Search EDP/AR # <span class="text-danger">*</span></label>
                <nz-select [(ngModel)]="selectedAREDP" (keydown)="onlyNumberKey($event)"
                    (nzOnSearch)="getEdpArNoList($event)" [nzServerSearch]="true" nzPlaceHolder="Search EDP/AR #"
                    nzSize="default" [nzShowSearch]="true" style="height: 35px !important;" [nzAllowClear]="true">
                    @for(edpAr of edpArList;track edpAr ){
                    <nz-option [nzLabel]="edpAr" [nzValue]="edpAr"></nz-option>
                    }
                     @if(selectedAREDP && !edpArList.includes(selectedAREDP)) {
                    <nz-option [nzLabel]="selectedAREDP" [nzValue]="selectedAREDP"></nz-option>
                    }
                </nz-select>
                <span class="error-text" *ngIf="invalidSearch && !selectedAREDP">
                    {{errorMessage}}
                </span>
            </div>
            <div class="col-md-4 d-flex">
                <button (click)="searchPriceDisplayList()" nz-button nzType="primary"
                    class="mt-2 d-flex align-items-center" [nzSize]="'default'">
                    Search
                </button>
            </div>
        </div>
        <div class="px-2 py-4 col-md-12 amd-list-container">
            <div class="col-md-12 px-4 searh-input-block d-flex align-items-center justify-content-between">

                <div class="col-md-6">
                    <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;"
                        nzSize="default" [nzSuffix]="suffixIconSearch">
                        <input type="number" class="py-1" nz-input placeholder="Search For EDP/AR #"
                            (keydown.enter)="searchPriceDisplay(SearchText.value)" [(ngModel)]="searchText" nzAllowClear
                            #SearchText />
                        <span class="close-icon" (click)="SearchText.value = '';searchPriceDisplay('')" class="px-1"
                            nz-icon nzType="close-circle"></span>

                    </nz-input-group>
                    <ng-template #suffixIconSearch>
                        <span class="search-icon" (click)="searchPriceDisplay(SearchText.value)" nz-icon
                            nzType="search"></span>
                    </ng-template>
                </div>
                <div class="d-flex">
                    <button (click)="reset()" nz-button nzType="primary" class="d-flex mr-5 align-items-center"
                        [nzSize]="'default'">
                        Reset
                    </button>
                    <button [disabled]="selectedPriceDisplay?.length==0" (click)="showModal = true" nz-button
                        nzType="primary" class="d-flex align-items-center mr-5" [nzSize]="'default'">
                        <span nz-icon nzType="delete"></span> Delete
                    </button>
                    <button (click)="updatePriceList(toggledRows)" [disabled]="toggledRows.length == 0 " nz-button
                        nzType="primary" class="d-flex align-items-center" [nzSize]="'default'">
                        Save
                    </button>
                </div>
            </div>
            <ng-container>
                <app-data-grid (toggledRows)="toggledRow($event)" [tableHeight]="'75vh'"
                    (selectedRows)="selectedRows($event)" (deleteRow)="deleteRow($event)" [frontPagination]="false"
                    [columns]="priceDisplayColumns" [dataSet]="priceDisplayData" [gridStyle]="'white'"></app-data-grid>
            </ng-container>
        </div>
    </div>
</div>
<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="1100" [nzVisible]="linkDrawer"
    nzTitle="Add Price Detail" (nzOnClose)="linkDrawer = false">
    <ng-container *nzDrawerContent>
        <app-add-edit-price-detail (emitData)="updatePriceList($event)"></app-add-edit-price-detail>
    </ng-container>
</nz-drawer>
<app-confirm-popup *ngIf="showModal" [title]="'Delete'"
    [message]="'Are you sure to delete the selected Price Display Setup records?'" [confirmText]="'Delete'"
    [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="deleteSelected()"
    (cancel)="showModal =false;"></app-confirm-popup>